module.exports = __webpack_public_path__ + "img/partner4.86997f66.png";